Controller.$inject = [];

function Controller() {

}

export function HuiPageFooter() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `<footer class="hui hui-page-footer d-flex justify-content-center align-items-center my-5"
                            ng-transclude>
                    </footer>`;
        }
    };
}